import { asString } from "./util";

interface Finding {
  rule_id?: string;
  severity?: string;
  coverage_status?: string;
  message?: string;
  recommendations?: string[];
  suggested_part_ids?: string[];
}

interface FindingsPayload {
  findings?: Finding[];
  support_findings?: Finding[];
  missing_data?: string[];
  unverified_claims?: string[];
}

const SEVERITY_LABELS: Record<string, { label: string; tone: string }> = {
  block: { label: "阻断", tone: "danger" },
  warn: { label: "警告", tone: "warn" },
  recommend: { label: "建议", tone: "info" },
  info: { label: "提示", tone: "info" },
};

const COVERAGE_LABELS: Record<string, string> = {
  modeled: "已建模",
  heuristic: "启发式",
  unmodeled: "未建模",
};

export function FindingsPanel({ payload }: { payload: unknown }) {
  const p = (payload ?? {}) as FindingsPayload;
  const findings = p.support_findings ?? p.findings ?? [];

  if (findings.length === 0 && !p.missing_data?.length && !p.unverified_claims?.length) {
    return <p className="muted small">没有支撑改装建议。</p>;
  }

  return (
    <div className="findings-list">
      {findings.map((f, idx) => {
        const sev = SEVERITY_LABELS[asString(f.severity, "info")] ?? {
          label: asString(f.severity, "—"),
          tone: "info",
        };
        const coverage = COVERAGE_LABELS[asString(f.coverage_status, "modeled")] ?? asString(
          f.coverage_status,
        );
        return (
          <article
            key={`${f.rule_id ?? "rule"}-${idx}`}
            className={`finding-card tone-${sev.tone}`}
          >
            <header>
              <span className={`finding-badge tone-${sev.tone}`}>{sev.label}</span>
              {coverage ? <span className="finding-coverage">{coverage}</span> : null}
              {f.rule_id ? <span className="finding-rule">{f.rule_id}</span> : null}
            </header>
            <p className="finding-message">{f.message ?? ""}</p>
            {f.recommendations?.length ? (
              <ul>
                {f.recommendations.map((r, ri) => (
                  <li key={ri}>{r}</li>
                ))}
              </ul>
            ) : null}
            {f.suggested_part_ids?.length ? (
              <p className="finding-parts">
                建议部件: <code>{f.suggested_part_ids.join(", ")}</code>
              </p>
            ) : null}
          </article>
        );
      })}
      {p.missing_data?.length ? (
        <div className="finding-meta">
          <strong>缺失数据：</strong>
          <span>{p.missing_data.join("、")}</span>
        </div>
      ) : null}
      {p.unverified_claims?.length ? (
        <div className="finding-meta">
          <strong>未验证主张：</strong>
          <span>{p.unverified_claims.join("、")}</span>
        </div>
      ) : null}
    </div>
  );
}
